import { actionTypes as batchJobsActionTypes } from 'Modules/Shared/actions/batchJobs';

export default id => action =>
  action.type === batchJobsActionTypes.JOB_FINISHED && action.payload.id === id;
